import { get } from 'lodash';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';

import { useBrazeImpression } from '@hooks/use-braze-impression';
import { PageHeader } from '@components/page-header';
import { Button } from '../../components/button/new';
import { ContentMatrix } from '../../components/content-matrix';
import { floodlightPageLoadEventPropTypes } from '../../prop-types';
import { Layout } from '../../components/layout';
import { makeInitialProps } from '../../utils/make-initial-props';
import { PeriPerksAppStore } from '../../components/peri-perks-app-store';
import { seoPropDefaults, seoPropTypes } from '../../utils/extract-seo-meta-from-entry';

const useBrazeContent = ({ heading, subheading }) => {
  const { BrazeStore } = useRootStore();

  const { getLatestContentCardExtraByType } = BrazeStore;
  const card = getLatestContentCardExtraByType('perks-signed-in');
  if (!card) {
    return { heading, subheading };
  }

  return {
    heading: get(card, 'heading', null),
    subheading: get(card, 'subheading', null),
    brazeLogImpression: card?.brazeLogImpression,
  };
};

const PeriPerks = ({ metaContent, floodlightPageLoadEvent, contentMatrix }) => {
  const { MemberStore } = useRootStore();
  const isSignedIn = !!MemberStore.profile;

  const content = {
    heading: 'Make bank\nwith every bite',
  };

  const { heading, brazeLogImpression } = useBrazeContent(content);

  useBrazeImpression({ brazeLogImpression });

  return (
    <Layout title="PERi-Perks" metaContent={metaContent} floodlightPageLoadEvent={floodlightPageLoadEvent}>
      <PageHeader
        heading={heading}
        eyebrow="Peri-Perks"
        eyebrowBackgroundColor="fuchsia1"
        eyebrowTextColor="black"
        image="/static/images/peri-perks/peri-perks-hero.jpg"
      >
        <Button
          display={{ xs: 'none', lg: 'flex' }}
          href={isSignedIn ? '/account' : '/create-account'}
          size="tall"
          widthType="fixed"
        >
          {isSignedIn ? 'My account' : 'Sign up'}
        </Button>
        <Button
          display={{ xs: 'flex', lg: 'none' }}
          href={isSignedIn ? '/account' : '/create-account'}
          size="medium"
          widthType="fixed"
        >
          {isSignedIn ? 'My account' : 'Sign up'}
        </Button>
      </PageHeader>

      <ContentMatrix hasExternalHeader lastBlockBottomPadding={false} blocks={contentMatrix} />

      <PeriPerksAppStore />
    </Layout>
  );
};

PeriPerks.getInitialProps = makeInitialProps('peri-perks');

PeriPerks.propTypes = {
  metaContent: PropTypes.shape(seoPropTypes),
  floodlightPageLoadEvent: floodlightPageLoadEventPropTypes,
  contentMatrix: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

PeriPerks.defaultProps = {
  metaContent: seoPropDefaults,
  floodlightPageLoadEvent: undefined,
};

export default observer(PeriPerks);
